import { FC } from 'react';

import { TemplateBadge } from 'entities/application/ui/TemplateBadge/TemplateBadge';
import { BadgeContainerStyled, NameStyled } from 'entities/application/ui/TemplateHeaderM/TemplateHeaderM.styles';
import {
	DeveloperStyled,
	HeaderDescriptionStyled,
	HeaderStyled,
	LogoMStyled,
} from '../ApplicaionHeaderM/ApplicationHeaderM.styles';

interface Props {
	name: string;
	description: string;
	logoUrl: string;
}

export const TemplateHeaderM: FC<Props> = ({ name, description, logoUrl }) => (
	<HeaderStyled>
		<LogoMStyled src={logoUrl} />
		<HeaderDescriptionStyled>
			<NameStyled>
				<span style={{ marginRight: `8px` }}>{name}</span>
				<BadgeContainerStyled>
					<TemplateBadge />
				</BadgeContainerStyled>
			</NameStyled>
			<DeveloperStyled>{description}</DeveloperStyled>
		</HeaderDescriptionStyled>
	</HeaderStyled>
);
